/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalGetAliasesAndPreferences} from '../api'

export const useMutationInternalGetAliasesAndPreferences = createReactQueryMutationHook('internalGetAliasesAndPreferences', internalGetAliasesAndPreferences)
